import {type RefObject, useCallback, useEffect, useRef, useState} from "react";

const SCROLL_ROUNDING_TOLERANCE_PX = 2;
const PENDING_SCROLL_TIMEOUT_MS = 600;

interface ISlotSliderScrollState {
    isScrollable: boolean;
    canScrollPrev: boolean;
    canScrollNext: boolean;
}

const INITIAL_SCROLL_STATE: ISlotSliderScrollState = {isScrollable: false, canScrollPrev: false, canScrollNext: false};

const prefersReducedMotion = (): boolean => typeof window !== "undefined" && Boolean(window.matchMedia?.("(prefers-reduced-motion: reduce)").matches);

export const useSlotSliderScroll = (listRef: RefObject<HTMLUListElement | null>) => {
    const [scrollState, setScrollState] = useState<ISlotSliderScrollState>(INITIAL_SCROLL_STATE);
    const pendingTargetRef = useRef<number | null>(null);
    const pendingTimeoutRef = useRef<number | null>(null);

    const readScrollState = useCallback(() => {
        const list = listRef.current;

        if (!list) {
            return;
        }

        const maxScrollLeft = list.scrollWidth - list.clientWidth;
        const nextState: ISlotSliderScrollState = {
            isScrollable: maxScrollLeft > SCROLL_ROUNDING_TOLERANCE_PX,
            canScrollPrev: list.scrollLeft > SCROLL_ROUNDING_TOLERANCE_PX,
            canScrollNext: list.scrollLeft < maxScrollLeft - SCROLL_ROUNDING_TOLERANCE_PX
        };

        setScrollState((currentState) =>
            currentState.isScrollable === nextState.isScrollable &&
            currentState.canScrollPrev === nextState.canScrollPrev &&
            currentState.canScrollNext === nextState.canScrollNext
                ? currentState
                : nextState
        );
    }, [listRef]);

    useEffect(() => {
        const list = listRef.current;

        if (!list) {
            return;
        }

        list.addEventListener("scroll", readScrollState, {passive: true});

        const resizeObserver = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(readScrollState);

        resizeObserver?.observe(list);

        return () => {
            list.removeEventListener("scroll", readScrollState);
            resizeObserver?.disconnect();
        };
    }, [listRef, readScrollState]);

    // Swapping the slides can leave the track the same size while its content changes, which no observer reports.
    useEffect(readScrollState);

    useEffect(() => {
        return () => {
            if (pendingTimeoutRef.current !== null) {
                window.clearTimeout(pendingTimeoutRef.current);
            }
        };
    }, []);

    const scrollByItems = useCallback(
        (direction: 1 | -1, itemsPerScroll: number) => {
            const list = listRef.current;

            if (!list) {
                return;
            }

            const firstItem = list.firstElementChild;
            const columnGap = Number.parseFloat(getComputedStyle(list).columnGap) || 0;
            const itemStep = firstItem ? firstItem.getBoundingClientRect().width + columnGap : list.clientWidth;
            // Clicking again mid-animation must continue from where the track is heading, not from where it currently is.
            const startingPoint = pendingTargetRef.current ?? list.scrollLeft;
            // A smooth scroll past either edge of a mandatory-snap container lands on an unrelated snap point in iOS Safari.
            const targetScrollLeft = Math.min(Math.max(startingPoint + direction * itemStep * itemsPerScroll, 0), list.scrollWidth - list.clientWidth);

            pendingTargetRef.current = targetScrollLeft;

            if (pendingTimeoutRef.current !== null) {
                window.clearTimeout(pendingTimeoutRef.current);
            }

            pendingTimeoutRef.current = window.setTimeout(() => {
                pendingTargetRef.current = null;
                pendingTimeoutRef.current = null;
            }, PENDING_SCROLL_TIMEOUT_MS);

            list.scrollTo({left: targetScrollLeft, behavior: prefersReducedMotion() ? "auto" : "smooth"});
        },
        [listRef]
    );

    return {...scrollState, scrollByItems};
};
import {type RefObject, useCallback, useEffect, useRef, useState} from "react";

const SCROLL_ROUNDING_TOLERANCE_PX = 2;
const PENDING_SCROLL_TIMEOUT_MS = 600;

interface ISlotSliderScrollState {
    isScrollable: boolean;
    canScrollPrev: boolean;
    canScrollNext: boolean;
}

const INITIAL_SCROLL_STATE: ISlotSliderScrollState = {isScrollable: false, canScrollPrev: false, canScrollNext: false};

const prefersReducedMotion = (): boolean => typeof window !== "undefined" && Boolean(window.matchMedia?.("(prefers-reduced-motion: reduce)").matches);

export const useSlotSliderScroll = (listRef: RefObject<HTMLUListElement | null>) => {
    const [scrollState, setScrollState] = useState<ISlotSliderScrollState>(INITIAL_SCROLL_STATE);
    const pendingTargetRef = useRef<number | null>(null);
    const pendingTimeoutRef = useRef<number | null>(null);

    const readScrollState = useCallback(() => {
        const list = listRef.current;

        if (!list) {
            return;
        }

        const maxScrollLeft = list.scrollWidth - list.clientWidth;
        const nextState: ISlotSliderScrollState = {
            isScrollable: maxScrollLeft > SCROLL_ROUNDING_TOLERANCE_PX,
            canScrollPrev: list.scrollLeft > SCROLL_ROUNDING_TOLERANCE_PX,
            canScrollNext: list.scrollLeft < maxScrollLeft - SCROLL_ROUNDING_TOLERANCE_PX
        };

        setScrollState((currentState) =>
            currentState.isScrollable === nextState.isScrollable &&
            currentState.canScrollPrev === nextState.canScrollPrev &&
            currentState.canScrollNext === nextState.canScrollNext
                ? currentState
                : nextState
        );
    }, [listRef]);

    useEffect(() => {
        const list = listRef.current;

        if (!list) {
            return;
        }

        list.addEventListener("scroll", readScrollState, {passive: true});

        const resizeObserver = typeof ResizeObserver === "undefined" ? null : new ResizeObserver(readScrollState);

        resizeObserver?.observe(list);

        return () => {
            list.removeEventListener("scroll", readScrollState);
            resizeObserver?.disconnect();
        };
    }, [listRef, readScrollState]);

    // Swapping the slides can leave the track the same size while its content changes, which no observer reports.
    useEffect(readScrollState);

    useEffect(() => {
        return () => {
            if (pendingTimeoutRef.current !== null) {
                window.clearTimeout(pendingTimeoutRef.current);
            }
        };
    }, []);

    const scrollByItems = useCallback(
        (direction: 1 | -1, itemsPerScroll: number) => {
            const list = listRef.current;

            if (!list) {
                return;
            }

            const firstItem = list.firstElementChild;
            const columnGap = Number.parseFloat(getComputedStyle(list).columnGap) || 0;
            const itemStep = firstItem ? firstItem.getBoundingClientRect().width + columnGap : list.clientWidth;
            // Clicking again mid-animation must continue from where the track is heading, not from where it currently is.
            const startingPoint = pendingTargetRef.current ?? list.scrollLeft;
            // A smooth scroll past either edge of a mandatory-snap container lands on an unrelated snap point in iOS Safari.
            const targetScrollLeft = Math.min(Math.max(startingPoint + direction * itemStep * itemsPerScroll, 0), list.scrollWidth - list.clientWidth);

            pendingTargetRef.current = targetScrollLeft;

            if (pendingTimeoutRef.current !== null) {
                window.clearTimeout(pendingTimeoutRef.current);
            }

            pendingTimeoutRef.current = window.setTimeout(() => {
                pendingTargetRef.current = null;
                pendingTimeoutRef.current = null;
            }, PENDING_SCROLL_TIMEOUT_MS);

            list.scrollTo({left: targetScrollLeft, behavior: prefersReducedMotion() ? "auto" : "smooth"});
        },
        [listRef]
    );

    return {...scrollState, scrollByItems};
};
